import FontSelect from './FontSelect'
export default FontSelect
export * from './FontSelect'
export * from './getFontOptions'
export * from './FontLoad'
